import ApplicationController from "../application_component_controller";
import URL from "hb/lib/url";
import hljs from "highlight.js/lib/core";

export default class extends ApplicationController {
  static targets = ["expressionGroup"];

  connect() {
    this.element.querySelectorAll("pre > code").forEach((ele) => {
      hljs.highlightElement(ele);
    });

    this.docLinkHandler = this.handleDocLink.bind(this);
    this.docCloseHandler = this.handleDocClose.bind(this);

    window.addEventListener("doclink", this.docLinkHandler);
    window.addEventListener("closedocs", this.docCloseHandler);

    this.openDocId(URL.getParam("doc"), false);
  }

  disconnect() {
    window.removeEventListener("doclink", this.docLinkHandler);
    window.removeEventListener("doclink", this.docLinkHandler);
  }

  handleExpressionFn({ params: { fn } }) {
    this.selectExpressionFn(fn);
  }

  handleDocLink(evt) {
    this.openDocId(evt?.detail?.link || evt?.params?.link, evt?.detail?.smooth);
  }

  openDocId(id, smooth = true) {
    if (id) {
      this.ensureDocsOpen();
      this.gotoLink(id, smooth);
    }
  }

  ensureDocsOpen() {
    const cl = document.querySelector(".search-wrap, .alarm-wrap").classList;
    cl.remove("container");
    cl.add("with-docs");
  }

  handleDocClose() {
    const cl = document.querySelector(".search-wrap, .alarm-wrap").classList;
    cl.add("container");
    cl.remove("with-docs");
  }

  gotoLink(id, smooth) {
    const [, fn] = id.split("expr-");
    if (fn) {
      this.gotoExpressionFn(fn, smooth);
    } else {
      this.gotoHeading(id, smooth);
    }
  }

  gotoHeading(id, smooth) {
    const sel = document.getElementById(id);
    if (sel === null) {
      return;
    }
    let offset = 0;
    const block = sel.closest(".block");
    if (block) {
      block.classList.add("expanded");

      if (sel === block) {
        offset = 40;
      } else {
        offset = 90;
      }
    }
    this.element.scrollTo({
      top: sel.offsetTop - offset,
      behavior: smooth ? "smooth" : "instant",
    });
  }

  gotoExpressionFn(id, smooth) {
    const block = this.selectExpressionFn(id);
    block.classList.add("expanded");
    this.element.scrollTo({
      top: block.offsetTop - 40,
      behavior: smooth ? "smooth" : "instant",
    });
  }

  selectExpressionFn(fn) {
    const sel = document.getElementById(`expSel-${fn}`);
    const desc = document.getElementById(`expDesc-${fn}`);
    if (sel === null || desc === null) {
      return;
    }
    const block = sel.closest(".block");
    block
      .querySelectorAll(`:scope .selected`)
      .forEach((e) => e.classList.remove("selected"));
    sel.classList.add("selected");
    desc.classList.add("selected");

    return block;
  }
}
